import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';


const ReferralChoice = ( { show } ) => {
    return (
        <Container fluid className='pt-2'>
            <Row>
                <Col>
                    <Form.Check type='radio' name='ctype' onChange={ ( e ) => show( 'find' ) } label='Contact already exists - just need to find them!' />
                    <Form.Check type='radio' name='ctype' onChange={ ( e ) => show( 'new' ) } label="New Blood - let's add 'em!" />
                </Col>
            </Row>
        </Container>
    )
}

export default ReferralChoice;